const EmptyNotificationsIcon = (props: any) => {
  return (
    <svg height="119" width="216" fill="none" viewBox="0 0 216 119" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx="108.5" cy="58.5" fill="#F1E7FF" r="58.5" />
      <g>
        <rect height="57" width="164" fill="#FCFAFF" rx="8" x="26" y="22" />
        <rect
          height="55.5"
          width="162.5"
          rx="7.25"
          stroke="url(#paint0_radial_6552_57675)"
          strokeOpacity="0.5"
          strokeWidth="1.5"
          x="26.75"
          y="22.75"
        />
        <rect
          height="55.5"
          width="162.5"
          rx="7.25"
          stroke="url(#paint1_radial_6552_57675)"
          strokeOpacity="0.4"
          strokeWidth="1.5"
          x="26.75"
          y="22.75"
        />
      </g>
      <g>
        <rect height="63" width="184" fill="#1A171E" rx="8" x="16" y="32" />
        <rect height="63" width="184" fill="url(#paint2_radial_6552_57675)" fillOpacity="0.22" rx="8" x="16" y="32" />
        <rect
          height="61.5"
          width="182.5"
          rx="7.25"
          stroke="url(#paint3_radial_6552_57675)"
          strokeWidth="1.5"
          x="16.75"
          y="32.75"
        />
        <rect
          height="61.5"
          width="182.5"
          rx="7.25"
          stroke="url(#paint4_radial_6552_57675)"
          strokeWidth="1.5"
          x="16.75"
          y="32.75"
        />
      </g>
      <g>
        <rect height="63" width="184" fill="#FBF9FF" rx="8" x="16" y="32" />
        <rect
          height="61.5"
          width="182.5"
          rx="7.25"
          stroke="url(#paint5_radial_6552_57675)"
          strokeWidth="1.5"
          x="16.75"
          y="32.75"
        />
        <rect
          height="61.5"
          width="182.5"
          rx="7.25"
          stroke="url(#paint6_radial_6552_57675)"
          strokeWidth="1.5"
          x="16.75"
          y="32.75"
        />
      </g>
      <rect height="7" width="62" fill="#E4D5FA" rx="3.5" x="99" y="46" />
      <rect height="7" width="58" fill="#E4D5FA" rx="3.5" x="99" y="74" />
      <rect height="7" width="85" fill="#E4D5FA" rx="3.5" x="99" y="60" />
      <path
        d="M67.9998 69.8031C67.9937 71.7021 66.4429 73.2384 64.5318 73.2384L44.4689 73.2329C42.5579 73.233 41.007 71.6967 41.001 69.7977C41.0029 68.8312 41.3916 67.9052 42.0815 67.224L44.3795 64.9386V58.1552C44.3805 52.6046 48.9073 48.1046 54.4931 48.1016C57.1784 48.0987 59.7548 49.1566 61.6548 51.0423C63.5548 52.9279 64.6226 55.4868 64.6231 58.1552V64.9441L66.9211 67.2294C67.6104 67.9108 67.9986 68.8369 67.9998 69.8031ZM51.2414 75.9526C50.6833 75.9526 50.2309 76.405 50.2309 76.9631C50.2309 77.5212 50.6833 77.9736 51.2414 77.9736H57.7584C58.3165 77.9736 58.7689 77.5212 58.7689 76.9631C58.7689 76.405 58.3165 75.9526 57.7584 75.9526H51.2414Z"
        fill="#E4D5FA"
        fillRule="evenodd"
      />
      <defs>
        <radialGradient
          id="paint0_radial_6552_57675"
          cx="0"
          cy="0"
          gradientTransform="translate(3.44199 14.9523) rotate(17.4928) scale(138.212 156.888)"
          gradientUnits="userSpaceOnUse"
          r="1"
        >
          <stop stopColor="#E9D8FF" />
          <stop offset="0.910585" stopColor="#7C2FE2" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="paint1_radial_6552_57675"
          cx="0"
          cy="0"
          gradientTransform="translate(203.578 86.1714) rotate(-159.602) scale(131.97 157.669)"
          gradientUnits="userSpaceOnUse"
          r="1"
        >
          <stop stopColor="#7142AE" />
          <stop offset="0.859375" stopColor="#E7D5FF" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="paint2_radial_6552_57675"
          cx="0"
          cy="0"
          gradientTransform="translate(13.3938 33.8639) rotate(19.0107) scale(208.028 137.637)"
          gradientUnits="userSpaceOnUse"
          r="1"
        >
          <stop stopColor="#AB87DC" />
          <stop offset="0.448096" stopColor="#8749D9" />
          <stop offset="1" stopColor="#D1BAEF" />
        </radialGradient>
        <radialGradient
          id="paint3_radial_6552_57675"
          cx="0"
          cy="0"
          gradientTransform="translate(-9.30898 24.2104) rotate(17.2481) scale(154.86 173.635)"
          gradientUnits="userSpaceOnUse"
          r="1"
        >
          <stop stopColor="#E9D8FF" />
          <stop offset="0.910585" stopColor="#7C2FE2" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="paint4_radial_6552_57675"
          cx="0"
          cy="0"
          gradientTransform="translate(215.233 102.926) rotate(-159.881) scale(147.798 174.579)"
          gradientUnits="userSpaceOnUse"
          r="1"
        >
          <stop stopColor="#7142AE" />
          <stop offset="0.859375" stopColor="#E7D5FF" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="paint5_radial_6552_57675"
          cx="0"
          cy="0"
          gradientTransform="translate(-9.30898 24.2104) rotate(17.2481) scale(154.86 173.635)"
          gradientUnits="userSpaceOnUse"
          r="1"
        >
          <stop stopColor="#E9D8FF" />
          <stop offset="0.910585" stopColor="#7C2FE2" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="paint6_radial_6552_57675"
          cx="0"
          cy="0"
          gradientTransform="translate(215.233 102.926) rotate(-159.881) scale(147.798 174.579)"
          gradientUnits="userSpaceOnUse"
          r="1"
        >
          <stop stopColor="#7142AE" />
          <stop offset="0.859375" stopColor="#E7D5FF" stopOpacity="0" />
        </radialGradient>
      </defs>
    </svg>
  );
};

export default EmptyNotificationsIcon;
